import React from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { useAuthState } from 'context';

export const SecuredRoute = (props: any) => {
  const { component: Component, path } = props;
  const { isAuthenticated } = useAuthState();

  return (
    <Route
      path={path}
      render={() => {
        if (!isAuthenticated) {
          return <Redirect to={'/login'} />;
        }
        return <Component />;
      }}
    />
  );
};

export default SecuredRoute;
